import { render, staticRenderFns } from "./SatisfactionSurveyComponent.vue?vue&type=template&id=bd0b0622&scoped=true&"
import script from "./SatisfactionSurveyComponent.vue?vue&type=script&lang=js&"
export * from "./SatisfactionSurveyComponent.vue?vue&type=script&lang=js&"
import style0 from "./SatisfactionSurveyComponent.vue?vue&type=style&index=0&id=bd0b0622&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0b0622",
  null
  
)

export default component.exports